import Error from '../components/common/Error';

const InternalServerError = () => {
  return (
    <Error
      message={'500 Internal Server Error\nアクセスしようとしたページは表示できませんでした。'}
    />
  );
};

export default InternalServerError;
